import React from 'react';
import PropTypes from 'prop-types';
import {
  useGetProductModulesAndPartsQuery,
} from '../../redux-modules/service';
import { Picture } from '../../components/ui/Picture';
import { DocumentFileDownloadTable } from '../../components/DocumentFileDownloadTable';
import { ScrewdriverWrench } from '../../components/ui/icon/ScrewdriverWrench';
import { Download } from '../../components/ui/icon/Download';

function ProductDetailModulesParts({
  productId,
  loadingText,
}) {
  const {
    data,
    isFetching,
  } = useGetProductModulesAndPartsQuery({ productId });

  if (isFetching) {
    return (<div className="container">{loadingText}</div>);
  }

  const {
    translates,
    modules,
    parts,
    title,
    introText,
  } = data;
  const { product } = translates;

  return (
    <div className="section-main">
      <div className="container">
        <div className="section-main-head">
          <div className="row align-item-center">
            <div className="col-12 col-lg">
              <h2>
                {(() => {
                  if (modules.length && parts) return Craft.t(product, 'Modules & Parts');
                  if (modules.length) return Craft.t(product, 'Modules');
                  if (parts) return Craft.t(product, 'Parts');
                  return '';
                })()}
              </h2>
            </div>
          </div>
        </div>

        {introText && (
          /* eslint-disable-next-line react/no-danger */
          <div className="mb-3a" dangerouslySetInnerHTML={{ __html: introText }} />
        )}

        {modules.map((module) => (
          <div key={`popup${module.id}`} className="popup-holder">
            <div className="main-modal" id={`modal-modules-${module.id}`}>
              <div className="main-modal-close-head" />
              <div className="video-wrap ratio ratio-16x9">
                <Picture image={module.modal} defaultTransform="lg-min" loading="lazy" imgClass="img-fluid" />
              </div>
              <h2>{`${module.category.title} - ${module.title}`}</h2>
              {/* eslint-disable-next-line react/no-danger */}
              <div className="text-black" dangerouslySetInnerHTML={{ __html: module.description }} />
              {module.highlightedText && (<p className="p-3 bg-gray-400">{module.highlightedText}</p>)}

              {module.files?.length > 0 && (
                <DocumentFileDownloadTable
                  documentFiles={module.files}
                  product={product}
                  options={{ showFileName: true, showDateUpdated: false, showFileSize: false }}
                />
              )}
            </div>
          </div>
        ))}

        <div className="row spacer-md">
          {modules.map((module) => (
            <div key={module.id} className="col-12 col-md-6 col-lg-4 d-flex">
              <a className="item-chock-icon main-modal-opener" href={`#modal-modules-${module.id}`}>
                <div className="item-frame">
                  {/* eslint-disable-next-line react/no-danger */}
                  <div className="img-wrap" dangerouslySetInnerHTML={{ __html: module.category.icon }} />
                  <div className="content">
                    <h3>{module.category.title}</h3>
                  </div>
                </div>
              </a>
            </div>
          ))}
          {parts && (
            <>
              <div className="popup-holder">
                <div className="main-modal rounded" id="modal-parts">
                  <div className="main-modal-close-head" />
                  <div className="main-modal-content">
                    <h2 className="mb-4">{Craft.t(product, 'Parts & accessories for {product}', { product: title })}</h2>

                    {parts.files && (
                      <DocumentFileDownloadTable
                        documentFiles={parts.files}
                        product={product}
                        options={{ showFileName: true, showDateUpdated: false }}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-12">
                <a className="item-chock-icon lg main-modal-opener" href="#modal-parts">
                  <div className="item-frame">
                    <div className="img-wrap">
                      <ScrewdriverWrench iconClass="svg-inline--fa" />
                    </div>
                    <div className="content">
                      <h3>{Craft.t(product, 'Parts & accessories')}</h3>
                      <p className="text-body">
                        {Craft.t(product, 'See our full list of parts & accessories available for the {product}', { product: title })}
                      </p>
                    </div>
                  </div>
                  <div className="btn btn-tertiary">
                    <Download />
                    {Craft.t(product, 'Download list')}
                  </div>
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

ProductDetailModulesParts.propTypes = {
  productId: PropTypes.string.isRequired,
  loadingText: PropTypes.string.isRequired,
};

export { ProductDetailModulesParts };
